import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { usePopper } from 'react-popper';
import { useClassName } from '../../hooks';
import { useOpen, useOnClick, useOnClickOutside, useOnMouseLeave, useOnMouseOver, useReferenceElement, useUpdatePosition } from './hooks';
import './Tooltip.scss';
import { useModifiers } from './hooks/useModifiers';
export const Tooltip = ({ children, content, behavior = 'hover', backgroundColor = 'white', placement, hidden, strategy = 'absolute', open: externalOpen, setOpen: externalSetOpen, preventAutoPositioning, }) => {
    const [open, setOpen] = useOpen({ open: externalOpen, setOpen: externalSetOpen });
    const popperElement = useRef(null);
    const onMouseOver = useOnMouseOver({ behavior, setOpen });
    const onMouseLeave = useOnMouseLeave({ behavior, setOpen });
    const onClick = useOnClick({ behavior, setOpen });
    const referenceElement = useReferenceElement({ onClick, onMouseLeave, onMouseOver });
    const modifiers = useModifiers({ preventAutoPositioning });
    const { styles, attributes, update } = usePopper(referenceElement.current, popperElement.current, {
        strategy,
        placement,
        modifiers,
    });
    const contentClassName = useClassName({
        name: 'tooltip-content',
        prefixed: true,
    }, !open && 'hidden', hidden && 'hidden', backgroundColor && `bg-${backgroundColor}`);
    useOnClickOutside({ behavior, popperElement, referenceElement, setOpen });
    useUpdatePosition({ update });
    return (_jsxs(_Fragment, { children: [children(referenceElement), _jsx("div", { ref: popperElement, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, className: contentClassName, style: styles.popper, ...attributes.popper, children: open && content })] }));
};
